/**
 * What became of a decision's send, in the Activity's words (`write_status`). One dictionary for the Activity and
 * the analyzers' decision detail (CU-869fmm949, plan § 3.1: "Activity's, not a second vocabulary").
 */
//: Decided is the event row; sent is a row of the write log pointing
//: back at it, written when the search closed (CU-869fb9wz6). The
//: server fills `write_status`: `ok`, `error`, `dry_run`, or
//: `not_sent` when no write row exists yet.
export const SENT_STYLE = {
	ok:       { tone: 'ok', label: 'sent' },
	dry_run:  { tone: 'accent', label: 'simulated' },
	error:    { tone: 'err', label: 'refused' },
	not_sent: { tone: 'info', label: 'not sent' },
	// The three faces of "not sent" the server tells apart since
	// CU-869f03vek (`@services/notSentReason`): still waiting for the
	// search's tasks (blue, like the plain word), sent once and waiting
	// for a re-send (blue), or sent through the sibling site's event
	// (grey: nothing of this row went out, nothing is pending).
	waiting_tasks:  { tone: 'info',    label: 'not sent · waiting' },
	pending_resend: { tone: 'info',    label: 're-send pending' },
	sibling_sent:   { tone: 'neutral', label: 'sent through sibling' },
	superseded: { tone: 'neutral', label: 'superseded' },
	// Decided, and the PMS already held that amount — so no call was
	// made. Not a refusal: writing it would have changed nothing and
	// split the operator's date range for nothing (Thibault).
	unchanged: { tone: 'neutral', label: 'already set' },
	// Decided, and another strategy took the bracket — by
	// priority, or by the bigger move on a tie (CU-869ffwj71). Grey like
	// the other two terminal non-sends: nothing went wrong. Not
	// `superseded`, which already means "a newer search went out first".
	outranked: { tone: 'neutral', label: 'outranked' },
	// The write log's states of the products (CU-869fhuhy6, § 4.4): a
	// send held by its markup cap, a row not converted (its site had no
	// decision and no markup), a late site whose group had already gone out.
	capped:           { tone: 'warn',    label: 'capped' },
	not_converted:    { tone: 'neutral', label: 'not converted' },
	late_not_applied: { tone: 'neutral', label: 'late · not applied' },
}

//: A status the dictionary does not know still gets a chip — grey, its
//: own word — never a red "refused" for something that may be fine
//: (`patterns.md` § 5).
export const sentStyleOf = (status) => SENT_STYLE[status] || { tone: 'neutral', label: String(status).replace(/_/g, ' ') }
